import { EventEmitter } from '../classes';
import { Rect } from './Rect';
import { Point } from './Point';
import { Size } from './Size';
var Viewport = /** @class */ (function () {
    function Viewport(props) {
        var _this = this;
        this.props = props;
        this.rect = new Rect(new Point(0, 0), new Size(this.props.minW || 1, this.props.minH || 1));
        this.emitter = new EventEmitter();
        window.addEventListener('resize', function () { return _this.onWindowResize(); });
        setTimeout(function () { return _this.onWindowResize(); }, 2500);
        if (DEVELOPMENT && props.debug) {
            this.debugArea = document.createElement('DIV');
            this.debugArea.style.fontSize = '20px';
            this.debugArea.style.fontFamily = 'monospace';
            this.debugArea.style.textAlign = 'center';
            this.debugArea.style.position = 'fixed';
            this.debugArea.style.zIndex = '100';
            this.debugArea.style.color = '#fff';
            this.debugArea.style.padding = '20px';
            this.debugArea.style.boxSizing = 'border-box';
            this.debugArea.style.textShadow = '0 0 2px rgba(0,0,0,0.75)';
            this.debugArea.style.backgroundColor = props.debugColor || 'rgba(0,0,255,0.5)';
            document.body.appendChild(this.debugArea);
        }
        this.update();
    }
    Viewport.prototype.getSize = function () {
        return this.rect.size;
    };
    Viewport.prototype.getPoint = function () {
        return this.rect.point;
    };
    Viewport.prototype.onChange = function (fn) {
        var _a = this.rect, size = _a.size, point = _a.point;
        this.emitter.subscribe('change', fn);
        setTimeout(function () { return fn({ size: size, point: point }); }, 1);
    };
    Viewport.prototype.onWindowResize = function () {
        this.update();
        var _a = this.rect, size = _a.size, point = _a.point;
        this.emitter.emit('change', { size: size, point: point });
    };
    Viewport.prototype.update = function () {
        var maxW = Math.min(window.innerWidth, this.props.maxW || window.innerWidth);
        var maxH = Math.min(window.innerHeight, this.props.maxH || window.innerHeight);
        var w = maxW;
        var h = maxH;
        if (this.props.ratio) {
            // ratio = h / w; h = ratio * w; w = h / ratio
            var ratioH = this.props.ratio * w;
            h = ratioH > maxH ? maxH : ratioH;
            w = h / this.props.ratio;
        }
        else {
            w = Math.max(w, this.props.minW || 1);
            h = Math.max(h, this.props.minH || 1);
        }
        var x = Math.ceil((window.innerWidth - w) / 2);
        var y = Math.ceil((window.innerHeight - h) / 2);
        this.rect.resize(w, h);
        this.rect.move(x, y);
        if (DEVELOPMENT && this.props.debug && this.debugArea) {
            this.debugArea.style.left = x + 'px';
            this.debugArea.style.top = y + 'px';
            this.debugArea.style.width = w + 'px';
            this.debugArea.style.height = h + 'px';
            this.debugArea.innerHTML = "".concat(this.rect.size.w, "x").concat(this.rect.size.h);
        }
    };
    return Viewport;
}());
export { Viewport };
